import yaml from 'js-yaml';

// Define types for the announcement configuration
export interface AnnouncementConfig {
  enabled: boolean;
  announcement: {
    id: string;
    message: string;
    backgroundColor: string;
    textColor: string;
    showIcon: boolean;
    ctaText?: string;
    ctaLink?: string;
    isInternalLink?: boolean;
  };
}

// Default configuration (fallback)
const defaultConfig: AnnouncementConfig = {
  enabled: false,
  announcement: {
    id: 'default-announcement',
    message: 'Important announcement',
    backgroundColor: '#3A4FD9',
    textColor: '#FFFFFF',
    showIcon: false
  }
};

// Function to load announcement configuration
export const getAnnouncementConfig = async (): Promise<AnnouncementConfig> => {
  try {
    // In a production environment, you would fetch the YAML file
    // For this example, we'll use the default config
    // const response = await fetch('/config/announcement.yaml');
    // const yamlText = await response.text();
    // const config = yaml.load(yamlText) as AnnouncementConfig;
    
    // Hardcoded for this example since we can't fetch files
    const config: AnnouncementConfig = {
      enabled: true,
      announcement: {
        id: "soc2-type1-certification-2023",
        message: "We are proud to announce our SOC2 Type 1 certification!",
        backgroundColor: "#3A4FD9",
        textColor: "#FFFFFF",
        showIcon: true
      }
    };
    
    return config;
  } catch (error) {
    console.error('Failed to load announcement configuration:', error);
    return defaultConfig;
  }
};

// Function to check if announcement is enabled
export const isAnnouncementEnabled = (config: AnnouncementConfig): boolean => {
  return config.enabled === true;
}; 